import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'react-feather';
import { useAuth } from '../../context/AuthContext';
import styles from './Header.module.css';

const Header = () => {
  const { isAuthenticated, user, logout } = useAuth();

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        {/* DISPLAY app logo and navigation */}
        <div className={styles.brand}>
          <Link to="/" className={styles.logoLink}>
            <img
              src="/insurtale-logo.webp"
              alt="insur_tale Logo"
              className={styles.logoImage}
            />
            <span className={styles.logoText}>Cipher</span>
          </Link>
        </div>

        <nav className={styles.nav}>
          <Link to="/create" className={styles.navLink}>
            Neues Secret erstellen
          </Link>

          {/* SHOW authentication status and controls */}
          <div className={styles.authSection}>
            {isAuthenticated ? (
              <div className={styles.userInfo}>
                <span className={styles.userName}>
                  Hallo {user?.username?.charAt(0).toUpperCase() + user?.username?.slice(1)}!
                </span>
                <button onClick={logout} className={styles.authButton}>
                  Logout
                </button>
              </div>
            ) : (
              <div className={styles.anonymousInfo}>
                <Lock size={16} className={styles.lockIcon} />
                <span className={styles.anonymousLabel}>Anonymer Modus</span>
              </div>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;